export default "__VITE_ASSET__DPltnm2E__"